import {CurrencyFormat} from 'ultra/helpers/utils';

import './index.scss';

export default function CurrencyFormated(props) {
    // currency: https://en.wikipedia.org/wiki/ISO_4217#List_of_ISO_4217_currency_codes
    // code: https://gist.github.com/ncreated/9934896
    const {value, sufix, currency, minimumFractionDigits} = props;

    return <span className='CurrencyFormated'><span className='value'>{CurrencyFormat(value, currency, minimumFractionDigits)}</span><span className='sufix'>{sufix}</span></span>
};
